import acaoProcesso from '../../constants/acaoProcesso'
import perfisMa from './perfis'
import status from '../status'
import tipoProcesso from '../tipoProcesso'
import acoesDj from './acoesDJ'
import setoresMA from '@/utils/ma/setor'
const { setores } = require('./setor').default

const exibirCSV = () => false

const verificarDespachoSemTexto = (usuario) => {
  return false
}

const perfisAnaliseConjunta = [
  perfisMa.AGENTE_ADMINISTRATIVO_PROTOCOLO,
  perfisMa.DIRETOR_DRF,
  perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
  perfisMa.CHEFE_SETOR_DF3,
  perfisMa.CHEFE_SETOR_DF1,
  perfisMa.PRESIDENTE_PRESIDENCIA,
  perfisMa.CHEFE_GABINETE_PRESIDENCIA,
  perfisMa.ADVOGADO_JURIDICO,
  perfisMa.COORDENADOR_CAF,
  perfisMa.DIRETOR_DAF,
  perfisMa.COORDENADOR_CADR,
  perfisMa.DIRETOR_DUF,
  perfisMa.COORDENADOR_CTT,
  perfisMa.CHEFE_SETOR_DATGL,
  perfisMa.CHEFE_SETOR_CAS,
  perfisMa.DIRETOR_DADR,
  perfisMa.COORDENADOR_CEP,
  perfisMa.CHEFE_SETOR_DEO,
  perfisMa.DIRETOR_DUA,
  perfisMa.CHEFE_SETOR_DGRH,
  perfisMa.CHEFE_SETOR_DMP,
  perfisMa.PROCURADOR_JURIDICO,
  perfisMa.GESTOR_SICARF,
  perfisMa.ANALISTA_CTRU
]

const rendaEnum = {
  '0a0': 'Menos que 1 salário mínimo',
  '1a3': '1 a 3 salários mínimos',
  '1a4': '1 a 4 salários mínumos',
  '4a5': '4 a 5 salários mínimos',
  'mais5': 'Mais de 5 salários mínimos'
}

const perfis = [
  perfisMa.SISTEMA,
  perfisMa.AGENTE_ADMINISTRATIVO_PROTOCOLO,
  perfisMa.DIRETOR_DRF,
  perfisMa.ASSESSOR_DRF,
  perfisMa.COORDENADOR_CAF,
  perfisMa.ASSESSOR_TECNICO_CAF,
  perfisMa.CHEFE_SETOR_DF1,
  perfisMa.TECNICO_DF1,
  perfisMa.CHEFE_SETOR_DF3,
  perfisMa.TECNICO_DF3,
  perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
  perfisMa.TECNICO_COMISSAO_ILHA,
  perfisMa.PROCURADOR_JURIDICO,
  perfisMa.ADVOGADO_JURIDICO,
  perfisMa.CHEFE_SETOR_DATGL,
  perfisMa.TECNICO_DATGL,
  perfisMa.PRESIDENTE_PRESIDENCIA,
  perfisMa.ASSESSOR_PRESIDENCIA,
  perfisMa.CHEFE_GABINETE_PRESIDENCIA,
  perfisMa.CHEFE_SETOR_CAS,
  perfisMa.TECNICO_CAS,
  perfisMa.COORDENADOR_CTT,
  perfisMa.ASSESSOR_TECNICO_CTT,
  perfisMa.DIRETOR_DADR,
  perfisMa.ASSESSOR_DADR,
  perfisMa.COORDENADOR_CEP,
  perfisMa.ASSESSOR_TECNICO_CEP,
  perfisMa.DIRETOR_DAF,
  perfisMa.ASSESSOR_DAF,
  perfisMa.COORDENADOR_CADR,
  perfisMa.ASSESSOR_TECNICO_CADR,
  perfisMa.DIRETOR_DUF,
  perfisMa.ASSESSOR_DUF,
  perfisMa.CHEFE_SETOR_DEO,
  perfisMa.ASSESSOR_DEO,
  perfisMa.DIRETOR_DUA,
  perfisMa.ASSESSOR_DUA,
  perfisMa.CHEFE_SETOR_DGRH,
  perfisMa.ASSESSOR_DGRH,
  perfisMa.CHEFE_SETOR_DMP,
  perfisMa.ASSESSOR_DMP,
  perfisMa.EXTERNO,
  perfisMa.PRODUTIVIDADE,
  perfisMa.AGENDAMENTO,
  perfisMa.GESTOR_DE_DEMANDAS,
  perfisMa.GOVERNADOR,
  perfisMa.MANUTENTOR,
  perfisMa.COMISSAO_GESTAO_SICARF,
  perfisMa.ADMINISTRADOR_PROCESSO,
  perfisMa.GESTOR_SICARF,
  perfisMa.ANALISTA_CTRU
]

const filtroDefaultSituacao = () => {
  return [
    perfisMa.DIRETOR_DRF,
    perfisMa.ASSESSOR_DRF,
    perfisMa.COORDENADOR_CAF,
    perfisMa.ASSESSOR_TECNICO_CAF,
    perfisMa.CHEFE_SETOR_DF1,
    perfisMa.TECNICO_DF1,
    perfisMa.CHEFE_SETOR_DF3,
    perfisMa.TECNICO_DF3,
    perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
    perfisMa.TECNICO_COMISSAO_ILHA,
    perfisMa.CHEFE_SETOR_DATGL,
    perfisMa.TECNICO_DATGL,
    perfisMa.COORDENADOR_CTT,
    perfisMa.ASSESSOR_TECNICO_CTT,
    perfisMa.DIRETOR_DUF,
    perfisMa.ASSESSOR_DUF,
    perfisMa.COORDENADOR_CEP,
    perfisMa.ASSESSOR_TECNICO_CEP,
    perfisMa.CHEFE_GABINETE_PRESIDENCIA,
    perfisMa.ASSESSOR_PRESIDENCIA,
    perfisMa.DIRETOR_DADR,
    perfisMa.ASSESSOR_DADR,
    perfisMa.COORDENADOR_CADR,
    perfisMa.ASSESSOR_TECNICO_CADR,
    perfisMa.AGENTE_ADMINISTRATIVO_PROTOCOLO,
    perfisMa.ANALISTA_CTRU
  ]
}

const findUsersDj = async (callBack) => {
  return {
    advogados: await callBack(perfisMa.ADVOGADO_JURIDICO),
    assessores: [],
    procuradores: await callBack(perfisMa.PROCURADOR_JURIDICO)
  }
}

const getUserBySetor = (callBack) => {
  return callBack(setores.DJ)
}

const tipoProcessoTitulo = [
  tipoProcesso.NAO_ONEROSO,
  tipoProcesso.ONEROSO
]

const filtroDefaultResponsavel = () => {
  return [
    perfisMa.DIRETOR_DRF,
    perfisMa.COORDENADOR_CAF,
    perfisMa.CHEFE_SETOR_DF1,
    perfisMa.CHEFE_SETOR_DF3,
    perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
    perfisMa.PROCURADOR_JURIDICO,
    perfisMa.CHEFE_SETOR_DATGL,
    perfisMa.COORDENADOR_CTT,
    perfisMa.DIRETOR_DUF,
    perfisMa.CHEFE_SETOR_CAS,
    perfisMa.COORDENADOR_CEP,
    perfisMa.PRESIDENTE_PRESIDENCIA,
    perfisMa.CHEFE_GABINETE_PRESIDENCIA,
    perfisMa.DIRETOR_DADR,
    perfisMa.COORDENADOR_CADR,
    perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
    perfisMa.GESTOR_SICARF,
    perfisMa.CHEFE_SETOR_GABINETE,
    perfisMa.ANALISTA_CTRU,
    perfisMa.AGENTE_ADMINISTRATIVO_PROTOCOLO
  ]
}

const perfisRegerar = () => {
  return []
}

const filtroDefaultReceita = () => {
  return [perfisMa.COORDENADOR_COF]
}

const filtroDefaultOrdemServico = () => {
  return [perfisMa.TECNICO_DE_CAMPO]
}

const filtroDefaultFuncao = () => {
  return [perfisMa.TECNICO_DE_CAMPO]
}

const filtroDefaultDataVencimento = () => {
  return [perfisMa.COORDENADOR_COF]
}

const filtroDefaultMunicipio = () => {
  return [
    perfisMa.SISTEMA,
    perfisMa.AGENTE_ADMINISTRATIVO_PROTOCOLO,
    perfisMa.DIRETOR_DRF,
    perfisMa.ASSESSOR_DRF,
    perfisMa.COORDENADOR_CAF,
    perfisMa.ASSESSOR_TECNICO_CAF,
    perfisMa.CHEFE_SETOR_DF1,
    perfisMa.TECNICO_DF1,
    perfisMa.CHEFE_SETOR_DF3,
    perfisMa.TECNICO_DF3,
    perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
    perfisMa.TECNICO_COMISSAO_ILHA,
    perfisMa.PROCURADOR_JURIDICO,
    perfisMa.ADVOGADO_JURIDICO,
    perfisMa.CHEFE_SETOR_DATGL,
    perfisMa.TECNICO_DATGL,
    perfisMa.PRESIDENTE_PRESIDENCIA,
    perfisMa.ASSESSOR_PRESIDENCIA,
    perfisMa.CHEFE_GABINETE_PRESIDENCIA,
    perfisMa.CHEFE_SETOR_CAS,
    perfisMa.TECNICO_CAS,
    perfisMa.COORDENADOR_CTT,
    perfisMa.ASSESSOR_TECNICO_CTT,
    perfisMa.DIRETOR_DADR,
    perfisMa.ASSESSOR_DADR,
    perfisMa.COORDENADOR_CEP,
    perfisMa.ASSESSOR_TECNICO_CEP,
    perfisMa.DIRETOR_DAF,
    perfisMa.ASSESSOR_DAF,
    perfisMa.COORDENADOR_CADR,
    perfisMa.ASSESSOR_TECNICO_CADR,
    perfisMa.DIRETOR_DUF,
    perfisMa.ASSESSOR_DUF,
    perfisMa.CHEFE_SETOR_DEO,
    perfisMa.ASSESSOR_DEO,
    perfisMa.DIRETOR_DUA,
    perfisMa.ASSESSOR_DUA,
    perfisMa.CHEFE_SETOR_DGRH,
    perfisMa.ASSESSOR_DGRH,
    perfisMa.CHEFE_SETOR_DMP,
    perfisMa.ASSESSOR_DMP,
    perfisMa.EXTERNO,
    perfisMa.PRODUTIVIDADE,
    perfisMa.AGENDAMENTO,
    perfisMa.GESTOR_DE_DEMANDAS,
    perfisMa.GOVERNADOR,
    perfisMa.GESTOR_SICARF,
    perfisMa.ANALISTA_CTRU
  ]
}

const filtroDefaultResponsavelPortaria = () => {
  return [perfisMa.GERENTE_GEO, perfisMa.ADMINISTRATIVO_GEO]
}

const montarFiltroRapido = async (opcoes) => {
  return {
    tipoRuralPendencia: opcoes[0].pendencia.find(p => p.id === 1).value,
    tipoSemRuralPendencia: opcoes[0].pendencia.find(p => p.id === 2).value,
    informacaoPendencia: opcoes[1].pendencia.find(p => p.id === 1).value,
    informacaoSemPendencia: opcoes[1].pendencia.find(p => p.id === 2).value
  }
}

function isCheckedRetornarEmissaoReurb (value) {
  return false
}

const separatorByUnderscore = (string = '') => {
  if (!string.includes('_')) return string
  else return string.split('_')[0]
}

const perfisGestaoProcesso = [
  perfisMa.AGENTE_ADMINISTRATIVO_PROTOCOLO,
  perfisMa.PRESIDENTE_PRESIDENCIA,
  perfisMa.CHEFE_GABINETE_PRESIDENCIA,
  perfisMa.PROCURADOR_JURIDICO,
  perfisMa.DIRETOR_DRF,
  perfisMa.COORDENADOR_CAF,
  perfisMa.DIRETOR_DAF,
  perfisMa.COORDENADOR_CADR,
  perfisMa.DIRETOR_DUF,
  perfisMa.COORDENADOR_CTT,
  perfisMa.CHEFE_SETOR_DATGL,
  perfisMa.CHEFE_SETOR_CAS,
  perfisMa.DIRETOR_DADR,
  perfisMa.COORDENADOR_CEP,
  perfisMa.CHEFE_SETOR_DEO,
  perfisMa.DIRETOR_DUA,
  perfisMa.CHEFE_SETOR_DGRH,
  perfisMa.CHEFE_SETOR_DMP,
  perfisMa.CHEFE_SETOR_DF1,
  perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
  perfisMa.CHEFE_SETOR_GABINETE,
  perfisMa.GESTOR_SICARF
]
const isVisualizarGestaoProcessos = (perfil) => perfisGestaoProcesso.includes(perfil)

const tiposModeloDefault = [1]

const showModeloTitulo = (formOptions) => {
  if (formOptions.despacho && this.exibirModelos.tipos.includes(formOptions?.despacho?.tipo) && this.exibirModeloTitulo) {
    return !this.naoExibirModelos.perfis.includes(formOptions?.despacho?.perfil)
  }
}

const acoesRetornarRevisao = [
  'RETORNO.SISTEMA.ANTERIOR',
  'SOLICITAR_ARQUIVAMENTO.DIRETOR.DRF.AUTOCOMPLETE',
  'ENCAMINHAMENTO.SISTEMA.CAF_REVISAO',
  'ENCAMINHAR.SISTEMA.CAF_REVISAO.AUTOCOMPLETE',
  'SOLICITAR_ARQUIVAMENTO.CHEFE_SETOR.COMISSAO_ILHA.AUTOCOMPLETE',
  'SOLICITAR_ARQUIVAMENTO.ANALISTA.COMISSAO_ILHA.AUTOCOMPLETE',
  'SOLICITAR_ARQUIVAMENTO.TECNICO.COMISSAO_ILHA.AUTOCOMPLETE',
  'ENCAMINHAMENTO.SISTEMA.COMISSAO_ILHA'
]
const tiposCadatrosSemRevisao = ['PEAEX', 'TQ', 'PEAS']
const acaoEmissao = [
  { id: 1, nome: 'Emitir título', valor: 'EMITIR' },
  { id: 2, nome: 'Despacho', valor: 'RETORNO' }
]
const acaoEmissaoVtn = [
  { id: 1, nome: 'Cálculo VTN', valor: 'CALCULO_VTN' },
  { id: 2, nome: 'Despacho', valor: 'DESPACHO' }
]
const acaoEmissaoCertidao = [
  { id: 1, nome: 'Emitir certidão', valor: 'EMITIR' },
  { id: 2, nome: 'Despacho', valor: 'REVISAO' }
]

const acaoReurbIndividual = {
  AGUARDANDO_CONFERENCIA_TITULO: 'Título emitido com sucesso!',
  FINALIZAR: 'Título emitido com sucesso!',
  SOLICITAR_ARQUIVAMENTO: 'Processo encaminhado para Comissão da ilha!'
}

const acoesRetornarRevisaoVTN = ['RETORNO.SISTEMA.ANTERIOR', 'SOLICITAR_ARQUIVAMENTO.SISTEMA.DRF_VTN.AUTOCOMPLETE', 'ENCAMINHAMENTO.SISTEMA.CAF_REVISAO.AUTOCOMPLETE', 'SOLICITAR_ARQUIVAMENTO.SISTEMA.COMISSAO_ILHA.AUTOCOMPLETE']
const isOpcoesGeo = (perfil, statusProcesso) => {
  const isComissaoIlha = [perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
    perfisMa.TECNICO_COMISSAO_ILHA, perfisMa.CHEFE_SETOR_DF1, perfisMa.TECNICO_DF1].includes(perfil)
  const statusProcessoDisponivelParaOpcao = (statusProcesso === status.EM_ANALISE_DOCUMENTAL ||
    statusProcesso === status.AGUARDANDO_VALIDACAO_DOCUMENTAL)
  return (
    (statusProcessoDisponivelParaOpcao &&
    this?.dadosCadastros?.despacho?.acao &&
    (this?.dadosCadastros?.despacho?.acao.includes('FINALIZAR.DF1') ||
      this?.dadosCadastros?.despacho?.acao.includes(
        'VALIDADO.CHEFE_SETOR.DF1'
      ) ||
      this?.dadosCadastros?.despacho?.acao.includes('FINALIZAR.DF3') ||
      this?.dadosCadastros?.despacho?.acao.includes(
        'VALIDADO.CHEFE_SETOR.DF3'
      ))
    ) || (statusProcessoDisponivelParaOpcao && isComissaoIlha)
  )
}

const perfilSetor = (callBack, setor) => {
  return []
}

const caixaAssinaturaConjunta = {
  textoButtonAssinatura: 'Assinar todos',
  visualizarModalAssinatura: true,
  visualizarModalAnalise: false,
  funcaoExibirModal: 'ASSINAR'
}

const caixaLaudo = {
  textoButtonAssinatura: 'Gerar todos',
  visualizarModa: true,
  funcaoExibirModal: 'GERAR_LAUDO'
}

const caixaAnaliseConjunta = {
  textoButtonAssinatura: 'Analisar todos',
  visualizarModalAssinatura: false,
  visualizarModalAnalise: true,
  funcaoExibirModal: 'ASSINAR_TITULOS'
}

const caixaValidacaoConjunta = {
  textoButtonAssinatura: 'Validar selecionados',
  visualizarModalAssinatura: false,
  visualizarModalAnalise: true,
  funcaoExibirModal: 'VALIDAR_SELECIONADOS'
}

const montarListagem = {
  'ASSINATURA_CONJUNTA': caixaAssinaturaConjunta,
  'ANALISE_CONJUNTA': caixaAnaliseConjunta,
  'ANALISE_COLETIVA': caixaAnaliseConjunta,
  'AGUARDANDO_VALIDACAO_ANALISE': caixaValidacaoConjunta,
  'LAUDO': caixaLaudo
}

const isRevisao = (action) => {
  return action === 'REVISAO'
}
const isRetorno = (action) => {
  return action === 'RETORNO'
}

const sendMessageToReoplay = (confirmMessage, titleMessage, message, send) => {
  send()
}

export default {
  isGcgCgir: (setor) => false,
  perfilSetor,
  tiposModeloDefault,
  acaoEmissaoCertidao,
  acaoEmissaoVtn,
  acaoEmissao,
  acoesRetornarRevisao,
  acoesRetornarRevisaoVTN,
  tiposCadatrosSemRevisao,
  verificarDespachoSemTexto,
  getOpcoesCredenciadoByPerfil: (perfil) => [],
  mensagemSucessoConferenciaTitulo: (respostaFinalizar) => {
    if (respostaFinalizar?.acao?.includes('FINALIZAR')) {
      return 'Título conferido com sucesso! Processo enviado para a Assinatura da Presidência.'
    } else if (respostaFinalizar?.acao?.includes('SOLICITAR_ARQUIVAMENTO')) {
      return 'Encaminhado para arquivamento!'
    } else if (respostaFinalizar?.acao?.includes('ENCAMINHAMENTO.SISTEMA.COMISSAO_ILHA_VTN')) {
      return 'Processo foi encaminhado para a emissão de VTN'
    } else if (respostaFinalizar?.acao?.includes('ENCAMINHAMENTO.SISTEMA.COMISSAO_ILHA')) {
      return 'Processo retornado para a comissão da ilha'
    } else if (respostaFinalizar?.acao?.includes('RETORNO')) {
      return 'Processo encaminhado para a reemissão de título'
    } else {
      let proximoSetorFormatado = 'próximo setor'
      if (setoresMA?.setoresFormatado[respostaFinalizar.proximoSetor]?.includes('-')) {
        proximoSetorFormatado = `setor ${setoresMA?.setoresFormatado[respostaFinalizar.proximoSetor]?.split('-')[0]}`
      } else if (setoresMA?.setoresFormatado[respostaFinalizar.proximoSetor]) {
        proximoSetorFormatado = `setor ${setoresMA?.setoresFormatado[respostaFinalizar.proximoSetor]}`
      }
      return `Análise finalizada. Processo enviado para o ${proximoSetorFormatado}.`
    }
  },
  isConversaPassivelDeArquivamento: () => {
    return false
  },
  isCheckedRetornarEmissaoReurb,
  cadastro: {
    exibirMapa: {
      setores: [setores.GCG],
      status: [status.EM_ANALISE, status.EM_REVISAO]
    },
    exibirAnexosBloqueio: {
      setores: []
    },
    exibirAnexosMonitoramento: {
      setores: []
    },
    exibirMapaTecnicoCampo: {
      setores: [setores.TECNICO_DE_CAMPO],
      status: [status.AGUARDANDO_ANALISE, status.EM_REVISAO]
    },
    exibirCodigoEstado: {
      setores: [setores.TECNICO_DE_CAMPO],
      status: [status.AGUARDANDO_ANALISE, status.EM_REVISAO]
    },
    exibirResponsavel: {
      setores: [],
      status: []
    },
    pegarResponsavel: {
      setores: [],
      status: []
    },
    exibirModelos: {
      tipos: ['ANALISE', 'REVISAO', 'RESPOSTA_REVISAO', 'VALIDACAO', 'TITULO_CERTIDAO']
    },
    naoExibirModelos: {
      perfis: [perfisMa.GOVERNADOR]
    },
    exibirModeloTitulo: true,
    perfisModeloTitulo: {
      perfis: [perfisMa.CHEFE_SETOR_DATGL, perfisMa.TECNICO_DATGL, perfisMa.ANALISTA_CTRU]
    },
    exibirModeloDespachoReurb: true,
    perfisModeloDespachoReurb: {
      perfis: perfisAnaliseConjunta
    },
    exibirModeloDespachoVistoria: false,
    perfisModeloDespachoVistoria: {
      perfis: []
    },
    exibirModeloJustificativa: true,
    perfisModeloJustificativa: {
      perfis: [perfisMa.ADMINISTRADOR_PROCESSO, perfisMa.MANUTENTOR]
    },
    exibirModeloExtratoSentenca: false,
    perfisModeloExtratoSentenca: {
      perfis: []
    },
    exibirModeloTituloReurb: true,
    perfisModeloTituloReurb: {
      perfis: [perfisMa.ANALISTA_CTRU]
    },
    exibirModeloDespacho: true,
    possuiTitulo: {
      acoes: ['ENCAMINHAMENTO.SISTEMA.DJ', 'AGUARDANDO_ENCAMINHAMENTO.SISTEMA.GIT.ENCAMINHAMENTO']
    },
    exibirBotoesDecisao: {
      setores: [setores.DJ]
    },
    statusBotoesDecisao: {
      status: []
    },
    podeInserirAnotacao: {
      perfis: [perfisMa.DIRETOR_GP],
      acoes: [acaoProcesso.ANALISAR]
    },
    decisoes: {
      DJ: {
        primeiro: 'Despacho',
        segundo: 'Parecer'
      }
    },
    getUserBySetor,
    findUsersDj,
    showSelecionaUsuarioDj: [acoesDj.AGUARDANDO_ANALISE_PROCURADOR_DJ.valor, acoesDj.AGUARDANDO_ANALISE_ASSESSOR_DJ, acoesDj.AGUARDANDO_ANALISE_ADVOGADO_DJ.valor],
    optionsRadios: [perfisMa.DIRETOR_JURIDICO_DJ, perfisMa.PROCURADOR_JURIDICO_DJ, perfisMa.PROCURADOR_ADMINISTRATIVO_DJ],
    radiosDJ: {
      DIRETOR_JURIDICO_DJ: {
        RADIOS_DESPACHO: [acoesDj.AGUARDANDO_ANALISE_ASSESSOR_DJ, acoesDj.AGUARDANDO_ANALISE_PROCURADOR_DJ,
          acoesDj.AGUARDANDO_ANALISE_ADVOGADO_DJ, acoesDj.AGUARDANDO_ANALISE_PROCURADOR_JURIDICO_DJ, acoesDj.AGUARDANDO_ANALISE_PROCURADOR_ADMINISTRATIVO_DJ],
        RADIOS_PARECER: [acoesDj.SOLICITAR_ARQUIVAMENTO_DIRETOR_GDA_AUTOCOMPLETE, acoesDj.ENCAMINHAR_GERENTE_GCG_AUTOCOMPLETE, acoesDj.ENCAMINHAR_SISTEMA_CDI_AUTOCOMPLETE,
          acoesDj.RETORNO_SISTEMA_ANTERIOR, acoesDj.ENCAMINHAR_DIRETOR_GP_AUTOCOMPLETE]
      },
      PROCURADOR_JURIDICO_DJ: {
        RADIOS_DESPACHO: [acoesDj.AGUARDANDO_ANALISE_ASSESSOR_DJ, acoesDj.AGUARDANDO_ANALISE_PROCURADOR_DJ,
          acoesDj.AGUARDANDO_ANALISE_ADVOGADO_DJ, acoesDj.AGUARDANDO_ANALISE_PROCURADOR_ADMINISTRATIVO_DJ,
          acoesDj.AGUARDANDO_ANALISE_DIRETOR_JURIDICO_DJ],
        RADIOS_PARECER: [acoesDj.AGUARDANDO_ANALISE_DIRETOR_JURIDICO_DJ]
      },
      PROCURADOR_ADMINISTRATIVO_DJ: {
        RADIOS_DESPACHO: [acoesDj.AGUARDANDO_ANALISE_ASSESSOR_DJ, acoesDj.AGUARDANDO_ANALISE_PROCURADOR_DJ,
          acoesDj.AGUARDANDO_ANALISE_ADVOGADO_DJ, acoesDj.AGUARDANDO_ANALISE_PROCURADOR_JURIDICO_DJ,
          acoesDj.AGUARDANDO_ANALISE_DIRETOR_JURIDICO_DJ],
        RADIOS_PARECER: [acoesDj.AGUARDANDO_ANALISE_DIRETOR_JURIDICO_DJ]
      }
    },
    exibirModeloRegistroImovel: false,
    perfisModeloRegistroImovel: {
      perfis: []
    },
    showModeloTitulo,
    notShowCardInfoTecnicoCampo: {
      status: [],
      funcoes: []
    }
  },

  notificarInteressado: {
    perfis: [
      perfisMa.AGENTE_ADMINISTRATIVO_PROTOCOLO,
      perfisMa.DIRETOR_DRF,
      perfisMa.ASSESSOR_DRF,
      perfisMa.COORDENADOR_CAF,
      perfisMa.ASSESSOR_TECNICO_CAF,
      perfisMa.CHEFE_SETOR_DF1,
      perfisMa.TECNICO_DF1,
      perfisMa.CHEFE_SETOR_DF3,
      perfisMa.TECNICO_DF3,
      perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
      perfisMa.TECNICO_COMISSAO_ILHA,
      perfisMa.PROCURADOR_JURIDICO,
      perfisMa.ADVOGADO_JURIDICO,
      perfisMa.CHEFE_SETOR_DATGL,
      perfisMa.TECNICO_DATGL,
      perfisMa.PRESIDENTE_PRESIDENCIA,
      perfisMa.ASSESSOR_PRESIDENCIA,
      perfisMa.CHEFE_GABINETE_PRESIDENCIA,
      perfisMa.CHEFE_SETOR_CAS,
      perfisMa.TECNICO_CAS,
      perfisMa.COORDENADOR_CTT,
      perfisMa.ASSESSOR_TECNICO_CTT,
      perfisMa.DIRETOR_DADR,
      perfisMa.ASSESSOR_DADR,
      perfisMa.COORDENADOR_CEP,
      perfisMa.ASSESSOR_TECNICO_CEP,
      perfisMa.DIRETOR_DAF,
      perfisMa.ASSESSOR_DAF,
      perfisMa.COORDENADOR_CADR,
      perfisMa.ASSESSOR_TECNICO_CADR,
      perfisMa.DIRETOR_DUF,
      perfisMa.ASSESSOR_DUF,
      perfisMa.CHEFE_SETOR_DEO,
      perfisMa.ASSESSOR_DEO,
      perfisMa.DIRETOR_DUA,
      perfisMa.ASSESSOR_DUA,
      perfisMa.CHEFE_SETOR_DGRH,
      perfisMa.ASSESSOR_DGRH,
      perfisMa.CHEFE_SETOR_DMP,
      perfisMa.ASSESSOR_DMP
    ]
  },

  solicitarRetificacao: {
    perfis: [
      perfisMa.AGENTE_ADMINISTRATIVO_PROTOCOLO,
      perfisMa.DIRETOR_DRF,
      perfisMa.ASSESSOR_DRF,
      perfisMa.COORDENADOR_CAF,
      perfisMa.ASSESSOR_TECNICO_CAF,
      perfisMa.CHEFE_SETOR_DF1,
      perfisMa.TECNICO_DF1,
      perfisMa.CHEFE_SETOR_DF3,
      perfisMa.TECNICO_DF3,
      perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
      perfisMa.TECNICO_COMISSAO_ILHA,
      perfisMa.PROCURADOR_JURIDICO,
      perfisMa.ADVOGADO_JURIDICO,
      perfisMa.CHEFE_SETOR_DATGL,
      perfisMa.TECNICO_DATGL,
      perfisMa.PRESIDENTE_PRESIDENCIA,
      perfisMa.ASSESSOR_PRESIDENCIA,
      perfisMa.CHEFE_GABINETE_PRESIDENCIA,
      perfisMa.CHEFE_SETOR_CAS,
      perfisMa.TECNICO_CAS,
      perfisMa.COORDENADOR_CTT,
      perfisMa.ASSESSOR_TECNICO_CTT,
      perfisMa.DIRETOR_DADR,
      perfisMa.ASSESSOR_DADR,
      perfisMa.COORDENADOR_CEP,
      perfisMa.ASSESSOR_TECNICO_CEP,
      perfisMa.DIRETOR_DAF,
      perfisMa.ASSESSOR_DAF,
      perfisMa.COORDENADOR_CADR,
      perfisMa.ASSESSOR_TECNICO_CADR,
      perfisMa.DIRETOR_DUF,
      perfisMa.ASSESSOR_DUF,
      perfisMa.CHEFE_SETOR_DEO,
      perfisMa.ASSESSOR_DEO,
      perfisMa.DIRETOR_DUA,
      perfisMa.ASSESSOR_DUA,
      perfisMa.CHEFE_SETOR_DGRH,
      perfisMa.ASSESSOR_DGRH,
      perfisMa.CHEFE_SETOR_DMP,
      perfisMa.ASSESSOR_DMP,
      perfisMa.ANALISTA_CTRU
    ]
  },

  filtro: {
    placeholder: 'Número do processo, Nome/Razão social do Interessado, CPF/CNPJ do interessado, ou Tipo do processo',
    showFiltroTipoProcessoMultiplo: true,
    showFiltroDataEmissaoTitulo: true,
    filtroSituacao: {
      CAIXA_ENTRADA: filtroDefaultSituacao(),
      EM_ANALISE: filtroDefaultSituacao(),
      AGUARDANDO_VALIDACAO_ANALISE: filtroDefaultSituacao(),
      INFORMACAO_SOLICITADA: filtroDefaultSituacao(),
      CAIXA_AGUARDANDO_OS: filtroDefaultSituacao(),
      EM_ANALISE_OS: filtroDefaultSituacao(),
      DAE: [perfisMa.DIRETOR_DUF, perfisMa.ASSESSOR_DUF],
      ARQUIVOS: [perfisMa.GERENTE_GEA, perfisMa.ANALISTA_GEA],
      CAIXA_PORTARIA_VALIDACAO: [perfisMa.GERENTE_GEO, perfisMa.ADMINISTRATIVO_GEO],
      CAIXA_PORTARIA_EMISSAO: [perfisMa.GERENTE_GEO, perfisMa.ADMINISTRATIVO_GEO],
      PROCESSO_ARQUIVADO: [perfisMa.GERENTE_GDA, perfisMa.DIRETOR_DRF, perfisMa.CHEFE_SETOR_DATGL, perfisMa.TECNICO_DATGL, perfisMa.CHEFE_SETOR_COMISSAO_ILHA, perfisMa.COMISSAO_GESTAO_SICARF],
      TITULO_CERTIDAO: [perfisMa.COORDENADOR_CDI, perfisMa.GERENTE_GIT, perfisMa.ANALISTA_GIT, perfisMa.PRESIDENTE_GP],
      TITULOS_PARA_ENTREGA: [perfisMa.CHEFE_GABINETE_PRESIDENCIA, perfisMa.ASSESSOR_PRESIDENCIA],
      CAIXA_EMISSAO_TITULO: [perfisMa.CHEFE_SETOR_DATGL, perfisMa.TECNICO_DATGL, perfisMa.ANALISTA_CTRU],
      PUBLICACAO: []

    },

    filtroResponsavel: {
      CAIXA_ENTRADA: filtroDefaultResponsavel(),
      EM_ANALISE: filtroDefaultResponsavel(),
      AGUARDANDO_VALIDACAO_ANALISE: filtroDefaultResponsavel(),
      PROCESSO_ARQUIVADO: filtroDefaultResponsavel(),
      EM_ANALISE_OS: filtroDefaultResponsavel(),
      CAIXA_AGUARDANDO_OS: filtroDefaultResponsavel(),
      ATUALIZACAO_BASE: [perfisMa.GERENTE_GCG],
      CAIXA_PORTARIA: filtroDefaultResponsavelPortaria(),
      CAIXA_PORTARIA_VALIDACAO: filtroDefaultResponsavelPortaria(),
      CAIXA_PORTARIA_EMISSAO: filtroDefaultResponsavelPortaria(),
      TITULOS_PARA_ENTREGA: [perfisMa.CHEFE_GABINETE_PRESIDENCIA, perfisMa.ASSESSOR_PRESIDENCIA],
      CAIXA_EMISSAO_TITULO: [perfisMa.CHEFE_SETOR_DATGL, perfisMa.TECNICO_DATGL, perfisMa.ANALISTA_CTRU],
      TITULO_CERTIDAO: [perfisMa.ANALISTA_CTRU]
    },

    filtroReceita: {
      CAIXA_ENTRADA: filtroDefaultReceita(),
      EM_ANALISE_OS: filtroDefaultReceita(),
      CAIXA_AGUARDANDO_OS: filtroDefaultReceita()
    },

    filtroMunicipio: {
      CAIXA_ENTRADA: filtroDefaultMunicipio(),
      EM_ANALISE: filtroDefaultMunicipio(),
      AGUARDANDO_VALIDACAO_ANALISE: filtroDefaultMunicipio(),
      EM_ANALISE_OS: filtroDefaultMunicipio(),
      CAIXA_AGUARDANDO_OS: filtroDefaultMunicipio(),
      TITULO_CERTIDAO: filtroDefaultMunicipio(),
      PUBLICACAO: []
    },

    filtroOrdemServico: {
      CAIXA_ENTRADA: filtroDefaultOrdemServico(),
      CAIXA_ENTRADA_OS: filtroDefaultOrdemServico(),
      EM_ANALISE_OS: filtroDefaultOrdemServico(),
      CAIXA_AGUARDANDO_OS: filtroDefaultOrdemServico(),
      EM_ANALISE: filtroDefaultOrdemServico(),
      INFORMACAO_SOLICITADA: filtroDefaultOrdemServico(),
      EDITAL_PUBLICACAO: [perfisMa.GERENTE_GPA, perfisMa.GERENTE_GCQ],
      ORDEM_SERVICO: [perfisMa.COORDENADOR_CAF, perfisMa.GERENTE_GPA, perfisMa.GERENTE_GCQ]
    },

    filtroFuncao: {
      CAIXA_ENTRADA: filtroDefaultFuncao(),
      EM_ANALISE_OS: filtroDefaultFuncao(),
      CAIXA_ENTRADA_OS: filtroDefaultFuncao(),
      CAIXA_AGUARDANDO_OS: filtroDefaultFuncao(),
      EM_ANALISE: filtroDefaultFuncao(),
      INFORMACAO_SOLICITADA: filtroDefaultOrdemServico()
    },

    filtroDataVencimento: {
      CAIXA_ENTRADA: filtroDefaultDataVencimento(),
      EM_ANALISE_OS: filtroDefaultDataVencimento(),
      CAIXA_AGUARDANDO_OS: filtroDefaultDataVencimento(),
      DAE: [perfisMa.GERENTE_GAC, perfisMa.ATENDENTE_GAC]
    },

    filtroStatusOrdemServico: {
      EDITAL_PUBLICACAO: [perfisMa.GERENTE_GPA, perfisMa.GERENTE_GCQ],
      ORDEM_SERVICO: [perfisMa.COORDENADOR_CAF, perfisMa.GERENTE_GPA, perfisMa.GERENTE_GCQ]
    },

    filtroTitulo: {
      TITULO_CERTIDAO: [perfisMa.COORDENADOR_CDI, perfisMa.GERENTE_GIT, perfisMa.ANALISTA_GIT]
    },

    filtroSituacaoTituloCertidaoSituacao: {
      TITULO_CERTIDAO: []
    },
    filtroSituacaoTituloCertidao: {
      TITULO_CERTIDAO: [perfisMa.PRESIDENTE_PRESIDENCIA, perfisMa.CHEFE_SETOR_DATGL, perfisMa.TECNICO_DATGL, perfisMa.DIRETOR_DRF, perfisMa.ASSESSOR_DRF, perfisMa.COMISSAO_GESTAO_SICARF, perfisMa.GESTOR_SICARF, perfisMa.ANALISTA_CTRU]
    },

    filtroRua: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_CONJUNTA: []
    },

    filtroBairro: {
      CAIXA_ENTRADA: [perfisMa.CHEFE_SETOR_COMISSAO_ILHA, perfisMa.TECNICO_COMISSAO_ILHA, perfisMa.CHEFE_SETOR_DATGL, perfisMa.TECNICO_DATGL, perfisMa.ANALISTA_CTRU],
      EM_ANALISE: [perfisMa.CHEFE_SETOR_DATGL, perfisMa.TECNICO_DATGL, perfisMa.CHEFE_SETOR_COMISSAO_ILHA, perfisMa.TECNICO_COMISSAO_ILHA, perfisMa.ANALISTA_CTRU],
      ANALISE_CONJUNTA: [],
      CAIXA_EMISSAO_TITULO: [perfisMa.CHEFE_SETOR_DATGL, perfisMa.TECNICO_DATGL, perfisMa.ANALISTA_CTRU],
      TITULO_CERTIDAO: [perfisMa.ANALISTA_CTRU]
    },

    filtroRemessa: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_CONJUNTA: []
    },

    filtroQuadra: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_CONJUNTA: []
    },

    filtroOS: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_CONJUNTA: []
    },
    filtroClausulaResolutiva: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_COLETIVA: []
    },
    filtroCredenciado: {
      RELATORIO_GRF_CAF_CREDENCIADOS: []
    },
    filtroCredenciadoGeo: {
      RELATORIO_GRF_CAF_CREDENCIADOS: []
    },
    filtroCaixaSobrestado: {
      CAIXA_SOBRESTADO: []
    },
    filtroVistoriador: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      AGUARDANDO_VALIDACAO_ANALISE: []
    },
    filtroPerfil: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: []
    },
    filtroSituacaoAssinatura: {
      ASSINATURAS: ['AGUARDANDO_ASSINATURA', 'AGUARDANDO_ASSINATURA_ERRATA_TITULO'],
      ASSINATURAS_REURB: ['AGUARDANDO_ASSINATURA', 'AGUARDANDO_ASSINATURA_ERRATA_TITULO']
    },
    filtroCpf: {
      CAIXA_ENTRADA: perfis,
      EM_ANALISE: perfis,
      PROCESSO_ARQUIVADO: perfis,
      PUBLICACAO: perfis,
      CAIXA_RETIFICACAO: perfis,
      CAIXA_EMISSAO_TITULO: perfis
    },
    filtroDataChegada: {
      CAIXA_ENTRADA: perfis,
      EM_ANALISE: perfis,
      PROCESSO_ARQUIVADO: perfis,
      PUBLICACAO: perfis,
      CAIXA_RETIFICACAO: perfis
    },
    filtroCadastrante: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      PROCESSO_ARQUIVADO: [],
      PUBLICACAO: []
    }
  },

  hasPermissaoNotificar: {
    PERFIS_PERMITIDOS: [setores.GIT, setores.CDI, setores.CAF, setores.GPA, setores.GCQ, setores.GCG,
      setores.CGIR, setores.DEAF, setores.GDA, setores.GRF, setores.GAM, setores.COF, setores.GEA,
      setores.GP, setores.DJ, setores.S1, setores.JURIDICO, setores.DF1, setores.CADR, setores.DUF,
      setores.CTT, setores.DRF, setores.DATGL, setores.PRESIDENCIA, setores.CAS, setores.DADR,
      setores.CEP, setores.DEO, setores.DUA, setores.DGRH, setores.DMP, setores.PROTOCOLO,
      setores.COMISSAO_ILHA
    ]
  },

  despacho: {
    perfisInserirAnotacao: [perfisMa.DIRETOR_GP],
    perfisInserirVisualizarAnotacao: [perfisMa.PRESIDENTE_GP]
  },

  tiposDocumentosVistoria: {
    tipos: [
      {id: 58, codigo: 'LAUDO_VISTORIA', descricao: 'Laudo de Vistoria'},
      {id: 59, codigo: 'OUTROS_VISTORIADOR', descricao: 'Outros'}
    ],
    obrigatorios: [
      {id: 58, codigo: 'LAUDO_VISTORIA', descricao: 'Laudo de Vistoria'}
    ]
  },

  tiposDocumentosRurb: {
    tipos: [
      {id: 288, codigo: 'PROJETO_URBANISTICO', descricao: 'Projeto Urbanístico'},
      {id: 289, codigo: 'OUTROS_REURB_COLETIVO', descricao: 'Outros'}
    ],
    obrigatorios: []
  },

  tiposDocumentosPortaria: {
    tipos: [
      {id: 162, codigo: 'OUTROS_MATRICULA', descricao: 'Outros'},
      {id: 260, codigo: 'PORTARIA_DE_ENCERRAMENTO', descricao: 'Portaria de encerramento'},
      {id: 291, codigo: 'OFICIO_SOLICITANDO_ABERTURA_MATRICULA', descricao: 'Ofício solicitando abertura de matrícula'},
      {id: 292, codigo: 'CERTIDAO_MATRICULA', descricao: 'Certidão de matrícula (resposta do cartório)'}
    ],
    obrigatorios: [
      {id: 292, codigo: 'CERTIDAO_MATRICULA', descricao: 'Certidão de matrícula (resposta do cartório)'}
    ]
  },
  tiposDocumentosGabinete: {
    tipos: [
      {id: 260, codigo: 'PORTARIA_DE_ENCERRAMENTO', descricao: 'Portaria de encerramento'},
      {id: 20, codigo: 'PLANTA', descricao: 'Planta'},
      {id: 21, codigo: 'MEMORIAL_DESCRITIVO', descricao: 'Memorial Descritivo'},
      {id: 148, codigo: 'ARQUIVO_SIGEF', descricao: 'Arquivos SIGEF'},
      {id: 188, codigo: 'ART_TRT', descricao: 'ART/TRT'},
      {id: 74, codigo: 'OUTROS_IMOVEL', descricao: 'Outros'}
    ],
    obrigatorios: [
    ]
  },

  tiposDocumentosSpu: {
    tipos: [
      {id: 283, codigo: 'EDITAL_REGULARIZACAO', descricao: 'Edital de Regularização'},
      {id: 284, codigo: 'OFICIO_CARTORIO', descricao: 'Ofício Cartório'},
      {id: 285, codigo: 'OFICIO_SPU', descricao: 'Ofício SPU'},
      {id: 286, codigo: 'OFICIO_PREFEITURA', descricao: 'Ofício Prefeitura'},
      {id: 160, codigo: 'OUTROS_SPU', descricao: 'Outros'}
    ],
    obrigatorios: [
    ]
  },

  tiposDocumentosSpuResposta: {
    tipos: [
      {id: 156, codigo: 'PUBLICACAO_EDITAL_REGULARIZACAO', descricao: 'Publicação do edital de regularização'},
      {id: 157, codigo: 'CERTIDAO_NEGATIVA_REGISTRO', descricao: 'Certidão negativa de registro'},
      {id: 158, codigo: 'RESPOSTA_OFICIO_SPU', descricao: 'Resposta do ofício do SPU'},
      {id: 159, codigo: 'RESPOSTA_OFICIO_PREFEITURA', descricao: 'Resposta do ofício da Prefeitura'},
      {id: 160, codigo: 'OUTROS_SPU', descricao: 'Outros'}
    ],
    obrigatorios: [
    ]
  },

  tiposDocumentosArquivosPublicacao: {
    tipos: [
      {id: 163, codigo: 'COPIA_DO_TITULO', descricao: 'Cópia do Título'},
      {id: 164, codigo: 'OUTROS_COPIA_DO_TITULO', descricao: 'Outros'}
    ],
    obrigatorios: [
      {id: 163, codigo: 'COPIA_DO_TITULO', descricao: 'Cópia do Título'}
    ]
  },

  tiposDocumentosRelatorio: {
    tipos: [
      {id: 166, codigo: 'RELATORIO_LEVANTAMENTO_OCUPACIONAL', descricao: 'Relatório de levantamento ocupacional'},
      {id: 167, codigo: 'RELATORIO_LEVANTAMENTO_FUNDIARIO', descricao: 'Relatório de levantamento fundiário'},
      {id: 168, codigo: 'RELATORIO_CARTORAL', descricao: 'Relatório cartorial'},
      {id: 169, codigo: 'OUTROS_RELATORIO', descricao: 'Outros'}
    ],
    obrigatorios: [
      {id: 167, codigo: 'RELATORIO_LEVANTAMENTO_FUNDIARIO', descricao: 'Relatório de levantamento fundiário'}
    ]
  },

  tiposDocumentosPublicacaoEdital: {
    tipos: [
      {id: 171, codigo: 'PUBLICACAO_EDITAL', descricao: 'Publicação do edital'},
      {id: 172, codigo: 'OUTROS_PUBLICACAO_EDITAL', descricao: 'Outros'}
    ],
    obrigatorios: [
      {id: 171, codigo: 'PUBLICACAO_EDITAL', descricao: 'Publicação do edital'}
    ]
  },

  tiposDocumentosDecreto: {
    tipos: [
      {id: 177, codigo: 'PUBLICACAO_DECRETO', descricao: 'Publicação do decreto'},
      {id: 178, codigo: 'OUTROS_PUBLICACAO_DECRETO', descricao: 'Outros'},
      {id: 179, codigo: 'DECRETO', descricao: 'Decreto'}
    ],
    obrigatorios: [
      {id: 177, codigo: 'PUBLICACAO_DECRETO', descricao: 'Publicação do decreto'},
      {id: 179, codigo: 'DECRETO', descricao: 'Decreto'}
    ]
  },

  tiposDocumentosPge: {
    tipos: [
      {id: 175, codigo: 'PARECER_PGE', descricao: 'Parecer da PGE'},
      {id: 176, codigo: 'OUTROS_PARECER_PGE', descricao: 'Outros'}
    ],
    obrigatorios: [
      {id: 175, codigo: 'PARECER_PGE', descricao: 'Parecer da PGE'}
    ]
  },

  tiposDocumentosDecisaoFinal: {
    tipos: [
      {id: 173, codigo: 'DECISAO_ASSINADA', descricao: 'Decisão assinada'},
      {id: 174, codigo: 'OUTROS_DECISAO_FINAL', descricao: 'Outros'}
    ],
    obrigatorios: [
      {id: 173, codigo: 'DECISAO_ASSINADA', descricao: 'Decisão assinada'}
    ]
  },

  tiposDocumentosPds: {
    tipos: [
      {id: 180, codigo: 'PLANO_DESENVOLVIMENTO_SOCIAL', descricao: 'Plano de desenvolvimento social'},
      {id: 181, codigo: 'OUTROS_PDS', descricao: 'Outros'}
    ],
    obrigatorios: [
      {id: 180, codigo: 'PLANO_DESENVOLVIMENTO_SOCIAL', descricao: 'Plano de desenvolvimento social'}
    ]
  },

  tiposDocumentosIncra: {
    tipos: [
      {id: 182, codigo: 'PORTARIA_RECONHECIMENTO_INCRA', descricao: 'Portaria de reconhecimento INCRA'},
      {id: 183, codigo: 'OUTROS_INCRA', descricao: 'Outros'}
    ],
    obrigatorios: [
      {id: 182, codigo: 'PORTARIA_RECONHECIMENTO_INCRA', descricao: 'Portaria de reconhecimento INCRA'}
    ]
  },

  tiposDocumentosGeorreferenciamento: {
    tipos: [
      {id: 112, codigo: 'ARQUIVOS_LITERAIS', descricao: 'Arquivos Literais'},
      {id: 113, codigo: 'ARQUIVOS_GRAFICOS', descricao: 'Arquivos Gráficos'},
      {id: 114, codigo: 'ARQUIVOS_GNSS', descricao: 'Arquivos GNSS'},
      {id: 148, codigo: 'ARQUIVO_SIGEF', descricao: 'Arquivos SIGEF'},
      {id: 89, codigo: 'OUTROS_GEOMENSOR', descricao: 'Outros'}
    ],
    obrigatorios: [
      {
        'id': 21,
        'codigo': 'MEMORIAL_DESCRITIVO',
        'descricao': 'Memorial Descritivo',
        'tipo': 'MEMORIAL_DESCRITIVO',
        'showValidacao': true
      },
      {
        'id': 20,
        'codigo': 'PLANTA',
        'descricao': 'Planta',
        'tipo': 'PLANTA',
        'showValidacao': true
      }
    ]
  },
  textoDocumentos: {
    OUTROS: `Os "Outros" deverão ser compostos por ART, DRL (Declaração de Reconhecimento de Limites)
    e outros arquivos que se fizerem necessários.`
  },

  messages: {
    headerTituloCertidao: 'Título',
    headerRetificacaoTituloCertidao: 'Errata de título',
    menuTituloCertidao: 'Títulos',
    outorgante: 'INSTITUTO DE COLONIZAÇÃO E TERRAS DO MARANHÃO'
  },

  isParecer: {
    JURIDICO: true
  },

  labelVisualizacaoProcesso: {
    etapaQualificacao: {
      area: 'Qual o tamanho da área?',
      cargoPublico: 'Você e/ou seu cônjuge exerce cargo ou função pública ou cargo eletivo?',
      possuiImovelRuralTitulado: 'Você e/ou seu cônjuge possui outro imóvel rural titulado?',
      ocupaImovelIlha: 'Ocupa e explora diretamente o imóvel de forma mansa e pacífica, por si ou por seus antecessores há no mínimo 5 (cinco) anos?',
      ocupaImovel: 'Ocupa e explora diretamente o imóvel de forma mansa e pacífica, por si ou por seus antecessores há no mínimo um ano?',
      exploracaoAgricola: 'A principal atividade exercida pelo requerente é a exploração agrícola do imóvel ou moradia?'
    },
    etapaInteressado: {
      titleSocioRepresentante: 'Sócio/Representante Legal'
    },
    etapaImovel: {
      numeroRecibo: 'Número do Recibo do CAR:',
      possuiImovel: 'Possui outros imóveis rurais em território nacional?'
    },
    etapaDestinacaoUsoImovel: {
      destinacaoUsoImovel: 'Destinação e uso do imóvel:'
    }
  },

  opcoesFiltroRapido: [
    {
      id: 1,
      titulo: 'Rural',
      pendencia: [
        { id: 2, label: 'Sem pendência', value: false },
        { id: 1, label: 'Com pendência', value: false }
      ]
    },
    {
      id: 2,
      titulo: 'Solicitações',
      pendencia: [
        { id: 2, label: 'Sem pendência', value: false },
        { id: 1, label: 'Com pendência', value: false }
      ]
    }
  ],

  defaultModeloDespacho: 1,

  showChatbotButton: false,

  analiseAutomatizada: {
    NAO_ONEROSO: {
      conclusao: ''
    },
    ONEROSO: {
      conclusao: ''
    },
    PEAEX: {
      conclusao: ''
    },
    TEQ: {
      conclusao: ''
    }
  },

  visualizarDocumentosPDF: {
    active: true,
    perfis: perfis,
    extensaoImagens: ['jpeg', 'png', 'jpg'],
    extensaoVisualizar: ['jpeg', 'png', 'jpg', 'pdf']
  },

  usePDFViewerOld: {
    active: false,
    minByteLength: 1048576
  },

  disableCadastrarCustas: true,

  montarFiltroRapido,

  exibirCSV,

  separatorByUnderscore,

  showValidacaoDocumentos: {
    perfis: [perfisMa.AGENTE_ADMINISTRATIVO_PROTOCOLO,
      perfisMa.DIRETOR_DRF, perfisMa.ASSESSOR_DRF,
      perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
      perfisMa.TECNICO_COMISSAO_ILHA,
      perfisMa.CHEFE_SETOR_DF3,
      perfisMa.TECNICO_DF3,
      perfisMa.CHEFE_SETOR_DF1,
      perfisMa.TECNICO_DF1]
  },

  visualizarBotaoVincularPessoa: false,
  visualizarBotaoSinalizarPendencia: true,

  rulesButtonConditionPdf: {
    show: true,
    tiposProcessos: [
      'REGULARIZACAO_URBANA',
      'REURB-S',
      'ONEROSO',
      'NAO_ONEROSO',
      'Não Oneroso',
      'Oneroso',
      'INFORMACOES',
      'PEAEX',
      'TEQ',
      'PEAES_FILHO',
      'TT',
      'PEAS',
      'CANCELAMENTO_CLAUSULA_RESOLUTIVA',
      'NAO_ONEROSO_FISICO',
      'ONEROSO_FISICO',
      'REURB_INDIVIDUAL',
      'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
    ],
    perfisDisableButtons: []
  },

  rulesButtonConditionZip: {
    show: true
  },

  rulesButtonConditionCopia: {
    show: false,
    perfisEnabled: []
  },

  desarquivamentoProcesso: {
    emitirBoleto: true,
    regrasExclusaoTipoProcesso: (tipoProcesso) => {
      return [].find(tipo => tipo === tipoProcesso)
    }
  },

  showVisualizarFluxo: true,

  rulesConditionCompareTab: {
    show: false,
    tiposProcessos: []
  },

  isVisualizarGestaoProcessos,

  isOpcoesGeo,
  rendaEnum,
  isTitulo: (tipo) => tipoProcessoTitulo.includes(tipo),
  telaFinal: 2,
  getMensagemEncaminhamentoTitulo: (codigo, acao, mensagemConfirmacao) => {
    switch (codigo) {
      case 'NAO_ONEROSO':
      case 'NAO_ONEROSO_FISICO':
        return acoesRetornarRevisao[0] === acao
          ? 'Processo encaminhado para o setor anterior'
          : mensagemConfirmacao[acao.split('.')[0]]
      case 'ONEROSO':
      case 'ONEROSO_FISICO':
        return acoesRetornarRevisao[0] === acao
          ? 'Processo encaminhado para o setor anterior'
          : mensagemConfirmacao[acao.split('.')[0]]
      case 'REURB_INDIVIDUAL':
        if (acoesRetornarRevisao[0] === acao) {
          return 'Processo encaminhado para o setor anterior'
        }
        if (acao === 'ENCAMINHAMENTO.SISTEMA.COMISSAO_ILHA') {
          return 'Processo retornado para a comissão da ilha'
        }
        return acaoReurbIndividual[acao.split('.')[0]]
      default: return ''
    }
  },
  showCsvButtonPermissions: ['CAIXA_ENTRADA', 'EM_ANALISE', 'AGUARDANDO_VALIDACAO_ANALISE', 'TITULO_CERTIDAO', 'PROCESSO_ARQUIVADO', 'ASSINATURAS', 'ASSINATURAS_REURB', 'CAIXA_EMISSAO_TITULO', 'CAIXA_RETIFICACAO', 'CAIXA_AGUARDANDO_PLANTA_MEMORIAL'],
  showGeorreferenciamentoAnexarDocumentosEShape: true,
  montarListagem,
  perfisRegerar,
  criarModelos: {
    perfisExcluidos: ['ATENDENTE', 'PROCURADORIA', 'ADM', 'GOVERNADOR', 'ADMINISTRATIVO', 'TECNICO'],
    perfisExcecoes: ['TECNICO_DATGL', 'TECNICO_CAS', 'TECNICO_COMISSAO_ILHA', 'TECNICO_DF1']
  },

  isDisabled (item, showButtonRegerar, usuario) {
    return usuario && usuario.perfilSelecionado.setor.codigo === 'CAF' && (item.disabled || item.retificacao || item.conversaAberta)
  },
  getAcao: (despacho, acoesRadio, acao) => {
    if (despacho.processo.tipo.codigo === 'TQ') {
      return acoesRadio.filter(
        action => action.valor !== 'ENCAMINHAMENTO.SISTEMA.CAF_REVISAO'
      )
    }
    return acoesRadio.filter(action => (isRevisao(acao) || isRetorno(acao))
      ? acoesRetornarRevisao.includes(action.valor)
      : !acoesRetornarRevisao.includes(action.valor)
    )
  },
  isAnaliseAutomatizada: (groupAnaliseAutomatizada, analiseManual, processo) => {
    return groupAnaliseAutomatizada && !analiseManual
  },
  continuarAnaliseManual: (_this, processo) => {
    _this.$router.push({
      name: 'analise/analisar',
      params: {
        idProcesso: processo.id,
        acaoCaixa: 'ANALISE'
      }
    })
    return false
  },
  conselhos: [],
  setoresArquivamentoTecnicoCampo: [],
  showAcaoDowloadDocumentos: () => { return false },
  tiposProcessoFisico: ['NAO_ONEROSO_FISICO', 'ONEROSO_FISICO'],
  showFiltroTipoMultiplo: true,
  sendMessageToReoplay,
  tiposImagensReurb: [
    'TERMO_ASSINATURA_APP_REURB',
    'IDENTIFICACAO_INTERESSADO',
    'CERTIDAO_NASCIMENTO',
    'IDENTIFICACAO_CONJUGE',
    'CERTIDAO_CASAMENTO_INTERESSADO',
    'COMPROVANTE_RESIDENCIA_INTERESSADO',
    'DECLARACAO_RENDA_FAMILIAR',
    'ATESTADO_OBITO_CONJUGE',
    'CERTIDAO_DIVORCIO',
    'DECLARACAO_UNIAO_ESTAVEL',
    'CERTIDAO_REGISTRO_CARTORIAL',
    'IPTU',
    'TITULO_EXPEDIDO_MUNICIPIO_OU_ESTADO',
    'DECLARACAO_POSSE_IMOVEL',
    'DECLARACAO_POSSE_RESIDENCIA',
    'OUTROS',
    'GALERIA',
    'RECIBOS',
    'DOCUMENTO_DE_IDENTIFICACAO_PESSOAL_INTERESSADO',
    'COMPROVANTE_RENDA',
    'COMPROVANTE_CADASTRO',
    'DOCUMENTO_DE_IDENTIFICACAO_PESSOAL_CONJUGE',
    'CERTIDAO_CASAMENTO_AVERBACAO_DIVORCIO_INTERESSADO',
    'LISTA_BENEFICIARIOS',
    'CERTIDAO_REGULARIDADE_MINISTERIO_PUBLICO',
    'ATA_ULTIMA_ELEICAO_REURB',
    'ESTATUTO_SOCIAL_ENTIDADE',
    'FACHADA_CASA',
    'SEPARACAO_FATO',
    'FACHADA_IMOVEL',
    'CNPJ'
  ],
  fluxosAssinatura: ['SUB_FLUXO_PRESIDENCIA_ONEROSO_FISICO', 'SUB_FLUXO_PRESIDENCIA_REURB_INDIVIDUAL', 'SUB_FLUXO_PRESIDENCIA', 'SUB_FLUXO_PRESIDENCIA_NAO_ONEROSO_FISICO'],
  selectItem (item, listaIDs) {
    if (!listaIDs) {
      listaIDs = []
    }
    const index = listaIDs.indexOf(item.id)
    if (index !== -1) {
      listaIDs.splice(index, 1)
      item.selecionado = false
    } else {
      listaIDs.push(item.id)
      item.selecionado = true
    }
  },
  cadastrarProtesto: {
    perfis: []
  },
  cancelarProtesto: {
    perfis: []
  },
  hasRetificacaoOnline: false,
  showTotalListagem: true,
  hasModuloRelatorioPrazo: false,
  setoresSemSigla: ['COMISSAO_ILHA', 'PRESIDENCIA', 'JURIDICO', 'PROTOCOLO', 'GABINETE']
}



// WEBPACK FOOTER //
// ./src/utils/ma/regrasAnalise.js